export interface SmsProgramData {
  countryCode: string;
  countryCallingCode: string;
  number: string;
  imgSrc: string;
  requiredTemplate: string;
  optionalTemplate: string;
}

export interface LegalText {
  required: string;
  optional: string;
}

export function getSmsProgramDataLegalText(
  smsProgramData: SmsProgramData[],
  defaultCountryCode: string,
  legalText: LegalText,
  isMultiCountryEnabled: boolean,
  required: boolean,
): string {
  if (
    !smsProgramData ||
    !Array.isArray(smsProgramData) ||
    smsProgramData.length === 0
  ) {
    return required ? legalText?.required : legalText?.optional;
  }

  if (isMultiCountryEnabled) {
    const defaultSMSProgramData = getDefaultCountryProgram(
      defaultCountryCode,
      smsProgramData,
    );
    if (required) {
      return (
        defaultSMSProgramData?.requiredTemplate || legalText?.required || ''
      );
    }
    return defaultSMSProgramData?.optionalTemplate || legalText?.optional || '';
  }

  if (required) {
    return smsProgramData[0]?.requiredTemplate || legalText?.required || '';
  }
  return smsProgramData[0]?.optionalTemplate || legalText?.optional || '';
}

export function getDefaultCountryProgram(
  defaultCountryCode: string,
  smsProgramData: SmsProgramData[],
): SmsProgramData | null {
  if (
    !smsProgramData ||
    !Array.isArray(smsProgramData) ||
    smsProgramData.length === 0
  ) {
    return null;
  }

  let defaultCountryProgramData;
  if (defaultCountryCode && smsProgramData) {
    defaultCountryProgramData = smsProgramData?.find(
      (program) => program?.countryCode === defaultCountryCode,
    );
  }

  const browserLanguage = getBrowserLanguage();
  let browserCountrySmsProgramData;
  if (browserLanguage && smsProgramData) {
    browserCountrySmsProgramData = smsProgramData?.find(
      (program) => program?.countryCode === browserLanguage,
    );
  }

  if (browserCountrySmsProgramData) {
    return browserCountrySmsProgramData;
  }

  if (defaultCountryProgramData) {
    return defaultCountryProgramData;
  }

  return smsProgramData[0];
}

export function getBrowserLanguage(): string {
  if (!window?.navigator?.language?.split('-')[1]) {
    return window?.navigator?.language?.toUpperCase();
  }
  return window?.navigator?.language?.split('-')[1];
}

export function getCountryUnicodeFlag(country: string): string {
  const flag = country
    .toUpperCase()
    .replace(/./g, (char) => String.fromCodePoint(char.charCodeAt(0) + 127397));
  return flag;
}
